import { render } from "./Carrousel2.vue?vue&type=template&id=26ea824c&scoped=true&lang=html"
import script from "./Carrousel2.vue?vue&type=script&lang=js"
export * from "./Carrousel2.vue?vue&type=script&lang=js"

import "./Carrousel2.vue?vue&type=style&index=0&id=26ea824c&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ea824c"]])

export default __exports__